import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const FormatHeaderNewIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            // eslint-disable-next-line max-len
            d='M7.25 3.75C7.80228 3.75 8.25 4.19772 8.25 4.75V11H15.75V4.75C15.75 4.19772 16.1977 3.75 16.75 3.75C17.3023 3.75 17.75 4.19772 17.75 4.75V12V19.25C17.75 19.8023 17.3023 20.25 16.75 20.25C16.1977 20.25 15.75 19.8023 15.75 19.25V13H8.25V19.25C8.25 19.8023 7.80228 20.25 7.25 20.25C6.69772 20.25 6.25 19.8023 6.25 19.25V4.75C6.25 4.19772 6.69772 3.75 7.25 3.75Z'
            fillRule='evenodd'
            clipRule='evenodd'
            fill='currentColor'
        />
    </svg>
));
